import qs from 'qs';
import { BASE_PLAN_CATEGORY_MAP } from '../constant';

export const generateBuyLink = (query = {}) => {
  return `${location.origin}/opc/buy?${qs.stringify(query)}`;
};

export const generatePlanCategory = (prefix, capacity) => {
  return `${prefix}${capacity ? capacity : ''}`;
};

export const getPlanCategoryFromServiceCategory = (serviceCategoryCode = '') => {
  const serviceCodeConditionList = [
    {
      condition: (c) => /^(zo)?(_)?pro/i.test(c),
      category: BASE_PLAN_CATEGORY_MAP.PRO,
    },
    {
      condition: (c) => /^biz/i.test(c),
      category: BASE_PLAN_CATEGORY_MAP.BIZ,
    },
  ];

  const info = serviceCodeConditionList.find((p) => {
    return p.condition(serviceCategoryCode);
  });

  return info ? info.category : '';
};
